import React, { FC } from "react";
import { VStack } from "@chakra-ui/react";
import { LeadReferralTableCell } from "../LeadReferralTableCell";
import { TLead } from "../../../../types/lead.type";

interface ILeadReferralCellProps {
  lead: TLead;
}

export const LeadReferralCell: FC<ILeadReferralCellProps> = ({ lead }) => {
  return (
    <VStack
      height={"100%"}
      justifyContent={"space-evenly"}
      alignItems={"flex-start"}
      spacing={0}
    >
      <LeadReferralTableCell
        leadReferredByAccount={lead.leadReferredByAccount}
        leadReferredByOffice={lead.leadReferredByOffice}
      />
    </VStack>
  );
};
